
import React from 'react';
import {DashboardContainer, Spinner} from "../../funcs/utils";
import {loadOnboardingRun} from "../../store/reducers/test-reducer";
import {CypressResults} from "./cypress-results";

const mk_date_str = timestamp => {
  const date = new Date(timestamp);
  return date.toLocaleDateString() + " " + date.toLocaleTimeString();
}

class E2ETests extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      gr_index: -1,
      run_index: -1,
      test_index: -1,
      detail: null,
    }

  }

  componentDidMount = () => {
    if (this.props.testRuns.groups.length === 0) {
      this.props.loadOnboardingRuns();
    }
  }

  on_mouse_over = (over, gr_index, run_index, test_index) => ev => {
    if (this.state.loading) {
      return;
    }
    if (over) {
      this.setState({
        gr_index,
        run_index,
        test_index,
      });
    } else {
      this.setState({
        gr_index: -1,
        run_index: -1,
        test_index: -1,
      })
    }
  }

  on_click = (group_index, run_index, test_index) => ev => {
    const path = this.props.testRuns.groups[group_index].runs[run_index].path;
    const detail = this.state.detail;
    if (detail && detail.gr_index === group_index
      && detail.run_index === run_index
      && detail.test_index === test_index) {
      // Just hide the current detail
      this.setState({ detail: null});
      return;
    }
    this.setState({
      loading: true,
    });

    loadOnboardingRun(this.props.user.token, path, test_index)
      .then(result => {
        if (result.status === "OK") {
          const tests = result.payload.tests;
          this.setState({
            loading: false,
            detail: {
              tests,
              gr_index: this.state.gr_index,
              run_index: this.state.run_index,
              test_index: this.state.test_index,
            }
          })
        } else {
          this.setState({ loading: false });
        }
      });

  }

  dump_run = (run, group_index, run_index) => {
    const tests = [];
    Object.keys(run.runs).forEach((title, test_index) => {
      const curr = run.runs[title];
      const sel = this.state.gr_index === group_index
        && this.state.run_index === run_index
        && this.state.test_index === test_index;
      const style = {
        fontWeight: sel ? "bold" : "normal",
        cursor: "pointer",
        color: curr.failed > 0 ? "red" : "black",
      }

      const detail = this.state.detail;
      const do_detail = detail
        && detail.gr_index === group_index && detail.run_index === run_index
        && detail.test_index === test_index;
      let detail_div = do_detail ?
        (<div style={{marginLeft: "1rem"}}>
          {detail.tests.map((test, index) => <CypressResults key={index} {...test}/>)}
        </div>) : null;

      const spinner = (sel && this.state.loading) ?
        (<Spinner size={"1.3rem"} style={{ fontWeight: "bold", marginLeft: "1rem"}}/>)
        : null;
      tests.push((
        <div key={test_index} style={{width: "50%"}}>
          <div
            key={test_index}>
            <div
              style={style}
              onClick={this.on_click(group_index, run_index, test_index)}
              onMouseOver={this.on_mouse_over(true, group_index, run_index, test_index)}
              onMouseOut={this.on_mouse_over(false, group_index, run_index, test_index)}>
              {title} {' '}{spinner}
            </div>
            { detail_div }
          </div>
        </div>

      ))
    })
    return (
      <div key={run_index}>
        <div>{mk_date_str(run.timestamp)}</div>
        <div style={{marginLeft: "2rem"}}>
          {tests}
        </div>
      </div>
    )
  }

  dump_groups = groups => {
    const results = [];

    const base_style = {
      margin: "1rem",
    }
    const title_style = {
      fontSize: "1.5rem",
      fontWeight: "bold",
    }
    groups.forEach((group, index) => {
      const name = group.name.charAt(0).toUpperCase() + group.name.slice(1);
      results.push((
        <div style={base_style} key={index}>
          <div style={title_style}>{name}</div>
          { group.runs.map((run, run_index) => this.dump_run(run, index, run_index))  }
        </div>
      ))
    });

    return results;
  }

  render = () => {
    const client = this.props.client;
    const container_style = {}
    const loading = this.props.testRuns.loading;
    const groups = this.props.testRuns.groups;

    return (
      <div className={"img-col"} style={container_style}>
        <DashboardContainer
          client={client}
          title={"End to End Test Runs"}
          spinner={loading}>
          { this.dump_groups(groups)}

        </DashboardContainer>
      </div>
    )
  }
}

export { E2ETests };
